import http from '@/communication/AuthConnection'

export default () => {
  return http.get('/v1/stage')
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/stage/ListStages.js